import React, { useState } from "react";
import { motion } from "framer-motion";
import { ArrowLeft, ShieldCheck } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { legalContent, LEGAL_TABS } from "../i18n/legal";
import { sfx } from "../lib/sound";

export const LegalScreen = ({ initialTab = "privacy", onBack }) => {
  const { t, lang } = useLang();
  const content = legalContent[lang] || legalContent.fr;
  const [tab, setTab] = useState(LEGAL_TABS.includes(initialTab) ? initialTab : "privacy");

  const sections = content[tab] || [];

  return (
    <div className="relative flex min-h-full flex-col px-6 py-8">
      <div className="flex items-center gap-3">
        <button
          onClick={() => {
            sfx.click();
            onBack();
          }}
          data-testid="legal-back-button"
          className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 bg-white/5 text-white/70 transition-transform hover:scale-105"
        >
          <ArrowLeft size={18} />
        </button>
        <div className="flex items-center gap-2 font-display text-sm font-bold uppercase tracking-widest text-white/60">
          <ShieldCheck size={16} className="text-[#f093fb]" /> Destin Express
        </div>
      </div>

      <motion.h1
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="mt-6 font-display text-3xl font-black uppercase tracking-tight text-white"
      >
        {content.tabs[tab]}
      </motion.h1>
      <p className="mt-1 text-xs text-white/40">{content.updated}</p>

      <div className="mt-5 flex flex-wrap gap-2">
        {LEGAL_TABS.map((k) => (
          <button
            key={k}
            onClick={() => {
              sfx.click();
              setTab(k);
            }}
            data-testid={`legal-tab-${k}`}
            className={`rounded-full border px-3 py-2 text-xs font-semibold transition-colors ${
              tab === k
                ? "border-transparent bg-gradient-to-r from-[#f093fb] to-[#f5576c] text-white"
                : "border-white/15 bg-white/5 text-white/60 hover:bg-white/10"
            }`}
          >
            {content.tabs[k]}
          </button>
        ))}
      </div>

      <motion.div
        key={tab}
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
        data-testid="legal-content"
        className="mt-6 space-y-6 pb-10"
      >
        {sections.map((s, i) => (
          <section key={i} className="rounded-2xl border border-white/8 bg-white/[0.03] p-5">
            <h2 className="font-display text-base font-bold text-white">{s.h}</h2>
            <div className="mt-3 space-y-2">
              {s.p.map((para, j) => (
                <p key={j} className="text-sm leading-relaxed text-white/70">
                  {para}
                </p>
              ))}
            </div>
          </section>
        ))}
      </motion.div>
    </div>
  );
};
